var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 0.604 0.01 C 0.67 0.02 0.709 0.043 0.764 0.082 C 0.859 0.145 0.933 0.229 0.971 0.349 C 1.031 0.551 0.938 0.765 0.832 0.863 C 0.778 0.905 0.718 0.946 0.647 0.968 C 0.301 1.061 0.051 0.842 0.01 0.541 C 0.088 0.56 0.158 0.588 0.234 0.577 C 0.446 0.553 0.613 0.361 0.618 0.179 C 0.629 0.118 0.611 0.057 0.604 0.01 Z M 0.725 0.181 C 0.723 0.253 0.686 0.412 0.577 0.52 C 0.509 0.591 0.446 0.623 0.367 0.649 C 0.237 0.679 0.206 0.674 0.154 0.676 C 0.184 0.739 0.236 0.786 0.295 0.821 C 0.329 0.843 0.367 0.86 0.406 0.871 C 0.639 0.943 0.81 0.764 0.867 0.617 C 0.954 0.354 0.751 0.197 0.725 0.181 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdle);
export default __webpack_public_path__ + "static/media/idle.24c99373a55ce559c666e80e8bbfa76d.svg";
export { ForwardRef as ReactComponent };